<nf-table-layout
  class="devtools-table-layout"
  [hideTitle]="true"
  [gridOptions]="gridOptions"
  [modules]="gridModules"
  [autoResizeGrid]="false"
  [data]="_data"
  hideSearch
  hideClearAll
>
</nf-table-layout>
